// extracted by mini-css-extract-plugin
export default {"container":"StoryRiver_container__wOehD"};